export const RETIREMENT_ACCOUNTS_SUMMARY_PROPORTION_CHART_AFTER_TAX_INVESTMENTS_COLOR =
  '#8B31F1';
export const RETIREMENT_ACCOUNTS_SUMMARY_PROPORTION_CHART_PRE_TAX_INVESTMENTS_COLOR =
  '#771DDD';
export const RETIREMENT_ACCOUNTS_SUMMARY_PROPORTION_CHART_OTHER_INVESTMENTS_COLOR =
  '#5D02C3';
